/**
 * Portal Manta · Gauge
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { M } from '../../tokens/colors.js';

function Gauge({value, label, size=120}){
  // value 0-100
  const r = size/2 - 10;
  const cx = size/2, cy = size/2;
  const angle = (value/100)*180 - 90; // -90 a +90 graus
  const rad = angle*Math.PI/180;
  const x = cx + r*Math.cos(rad-Math.PI/2);
  const y = cy + r*Math.sin(rad-Math.PI/2);
  const cor = value>=70 ? V.gn : value>=50 ? V.or : '#C45A2B';
  return (<div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
    <svg width={size} height={size/2+12} viewBox={`0 0 ${size} ${size/2+12}`}>
      <path d={`M 10 ${cy} A ${r} ${r} 0 0 1 ${size-10} ${cy}`} stroke={V.g1} strokeWidth="14" fill="none" strokeLinecap="round"/>
      <path d={`M 10 ${cy} A ${r} ${r} 0 0 1 ${x} ${y}`} stroke={cor} strokeWidth="14" fill="none" strokeLinecap="round"/>
      <text x={cx} y={cy-5} textAnchor="middle" fontSize="22" fontWeight="700" fill={cor} fontFamily="monospace">{value}</text>
      <text x={cx} y={cy+10} textAnchor="middle" fontSize="9" fill={V.g4}>0—100</text>
    </svg>
    <div style={{fontSize:10.5,fontWeight:600,color:V.g7,marginTop:2}}>{label}</div>
  </div>);
}

export { Gauge };
export default Gauge;
